export default "__VITE_ASSET__ByzkCqey__"